<template>
  <div class="videoCom" :style="{opacity:config.opacity}">
    <video-player class="video-player vjs-custom-skin"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="config.agreement === 'http'?httpPlayerOptions:rtmpOptions"
    ></video-player>
  </div>
</template>

<script>
/**
 @author xcf
 @date 2020/6/29 3:57 下午
 */
import 'videojs-contrib-hls'
import {videoPlayer} from "vue-video-player";
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
require('videojs-flash');
require('videojs-contrib-hls');
export default {
  name: 'videoCom',
  components: {
    videoPlayer
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default: ''
    },
    trans: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      httpPlayerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'application/x-mpegURL', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: 'http://ivi.bupt.edu.cn/hls/cctv1hd.m3u8' // url地址，从别的博主那看来的地址，亲测可用
        }],
        poster: "./img/icon00.png", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          fullscreenToggle: true  //全屏按钮
        }
      },
      rtmpOptions: {
        height: "300",
        width: "600",
        sources: [
          {
            type: "rtmp/mp4",
            src: "rtmp://58.200.131.2:1935/livetv/hunantv",
          },
        ],
        techOrder: ["flash"],
        autoplay: true,
        controls: true,
      }
    }
  },
  computed: {
    config() {
      if (this.type === 'view') {
        return this.$store.state.viewDP.chart.setting.params;
      } else if (this.type === 'screen') {
        return this.option.setting.params;
      }
    },
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  methods: {
    onPlayerPlay(player) {
      const myPlayer = this.$refs.videoPlayer.player;
      myPlayer.play();
    },

  },
  mounted() {
    this.onPlayerPlay(this.$refs.videoPlayer.player);
  },
  watch: {
    config(a) {
      this.rtmpOptions.sources[0].src = a.url;
      this.httpPlayerOptions.sources[0].src = a.url;
    }
  },
  created() {
  },
  destroyed() {

  }
}
</script>

<style lang="less">
.videoCom {
  > div {
    width: 100%;
    height: 100%;
    background-size: 100% 100% !important;

    .video-js {
      height: 100%;
    }
  }
}
</style>
